
	import { defineComponent } from 'vue';

	export default defineComponent({
		name: 'Popup',
		emits: ['playagain'],
		methods: {
			playAgain() {
				this.$emit('playagain');
			},
		},
	});
